import React from 'react';
import Video from './index';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import LayersControl from '../../utils/LayersControl';
import AAFPlayer from '../../AAFPlayer/AAFPlayer';
import { AAFPLAYER_PLAY, AAFPLAYER_STOP } from '../../AAFPlayer/constants';
import Utils from '../../utils/Utils';
import Device from './../../devices/device';
import { bindActionCreators } from 'redux';
import { setResumeData } from '../../actions/resume';
import PlayerHelper from '../../AAFPlayer/helpers/PlayerHelper';
import * as constant from '../../AAFPlayer/constants';
import BlockedChannels from '../../utils/BlockedChannels';
import { MODAL_PIN } from '../../actions/modal';
import PlayerStreamingUtils from '../../utils/PlayerStreamingUtils';
import channelBlockedUtil from '../../utils/ChannelBlockedUtil';
import { MODAL_PIN_CODE_CHANNEL_TYPE } from '../Modal/ModalPinCode';
import { ThirdPartyEpgHelper } from '../../AAFPlayer/helpers/ThirdPartyEpgHelper';
import { setValuesStoreModalKeepWatching } from 'src/components/Modal/functions/ModalKeepWatching/functions';
import store from '../../store';
class FullVideo extends Video {
  static contextTypes = {
    router: PropTypes.object
  };

  constructor(props, context) {
    super(props, context);
    this.isPlayerFull = true;
    this.goBack = this.goBack.bind(this);
    this.goToLastPlayedVCard = this.goToLastPlayedVCard.bind(this);
  }

  enableControls() {
    return this.playeIsOnScreen;
  }

  shouldForceChange(player) {
    let itShould = false;
    let playerOptions = AAFPlayer.getCurrentPlayerOptions(false);
    let playerState = AAFPlayer.getCurrentPlayingState(false);
    if (
      playerState === AAFPLAYER_PLAY &&
      playerOptions.islive &&
      !playerOptions.ispip &&
      !isNaN(playerOptions.source.videoid) &&
      !isNaN(player.source.videoid) &&
      playerOptions.source.videoid !== player.source.videoid
    ) {
      itShould = true;
    }
    return itShould;
  }

  async updateBlockedChannels(nextProps) {
    return new Promise((resolve, reject) => {
      if (
        !nextProps.islive ||
        this.hasSameVideoIdPlaying(nextProps.source && nextProps.source.videoid)
      ) {
        resolve(false);
      } else {
        let blockedChannelsList = new BlockedChannels();
        blockedChannelsList
          .checkBlockedChannels()
          .then(response => {
            channelBlockedUtil.set('blockedChannels', response);
            resolve(true);
          })
          .catch(error => {
            channelBlockedUtil.set('blockedChannels', []);
            resolve(false);
          });
      }
    });
  }

  /*
   * Método que nos dice si existe la url para reproducción en fastPlay
   */

  isFastPlay(groupId) {
    let itIs = false;
    this.platform = Device.getDevice().getPlatform();
    let supported_stream_types = Utils.getApaSupportedStream(this.platform);
    let channel_url_data = PlayerHelper.getLiveURL(groupId, supported_stream_types['live']);
    // Si hay url, se cambia la url de playing
    if (channel_url_data && channel_url_data.live_url) {
      itIs = true;
    }
    return itIs;
  }

  canPlay(groupId) {
    let playerStreamingUtils = new PlayerStreamingUtils();
    return playerStreamingUtils.canPlayChannel(groupId) ? true : false;
  }

  hasSameVideoIdPlaying(groupId) {
    let itHas = false;
    let playerOptions = AAFPlayer.getCurrentPlayerOptions(false);
    let playerState = AAFPlayer.getCurrentPlayingState(false);
    if (
      playerState === AAFPLAYER_PLAY &&
      !isNaN(playerOptions.source.videoid) &&
      !isNaN(groupId) &&
      playerOptions.source.videoid === groupId
    ) {
      itHas = true;
    }
    return itHas;
  }

  componentWillReceiveProps(nextProps) {
    /**
     * Esta variable es importante, es la que le indica a PlayerControls main
     * qué variante de pimport { store } from 'src/store';
layer controls montará: import { store } from 'src/store';
live, st, ctup, npvr
     */
    //Quita el foco dinámico cuando no hay elementos activos con foco
    Utils.setInitialFocusChangeTime("",0)

    this.nextContentStreamType = AAFPlayer.getContentType(nextProps.player);
    console.log('Video/index, calcula nextContentStreamType: ', this.nextContentStreamType, ' con nextProps: ', nextProps.player);

    //console.log('[EPGFILTER] BACK, Videocomponent componentWillReceiveProps ', nextProps.player);
    const withFilter = nextProps.player && nextProps.player.showEpg && !isNaN(nextProps.player.filterTV);
    if (nextProps.player && nextProps.player.params) {
      if (nextProps.player.params.epgtype === 'GUIDE' || nextProps.player.params.epgtype === 'MOSAIC') {
      if (!this.hasEpgError()) {
        this.showEPG(nextProps.player.params.epgtype);
      }
    }
    delete nextProps.player.params;
  }

    /*
     * Nueva lógica agregada para detener la reproducción en contenido live y con bloqueo parental solo hasta que el pin
     * sea escrito enviado correctamente por medio del modal.
     * La lógica anterior fue encapsulada en el método "afterWillReceiveProps".
     */
    let playersAreDifferent =
      nextProps.player &&
      JSON.stringify(nextProps.player) !== JSON.stringify(this.props.player);
    if (playersAreDifferent || this.shouldForceChange(nextProps.player)) {
      if (withFilter) {
        if (
          nextProps.player.source &&
          this.isLivePinBlocked(nextProps.player.source.videoid) &&
          !this.isFastPlay(nextProps.player.source.videoid)
        ) {
          //Se revisa si el canal está bloqueado
          nextProps.player.modalHasBeenShown = false;
          if (
            (!this.unblockedContent || !this.isModalActive) &&
            this.canPlay(nextProps.player.source.videoid)
          ) {
            let isSourceReplace = true;
            nextProps.player.modalHasBeenShown = true;
            let nextOptions = nextProps.player;
            let modalData = {
              modalType: MODAL_PIN,
              type: MODAL_PIN_CODE_CHANNEL_TYPE,
              successCallBack: () => {
                this.unblockedContent = true;
                this.isModalActive = false;
                this.afterWillReceiveProps(nextProps);
              },
              nextOptions: nextOptions,
              isSourceReplace: isSourceReplace,
              failedCallBack: () => {
                this.isModalActive = false;
                if (nextOptions.islive) {
                  this.unblockedContent = false;
                }
              }
            };
            if (this.hasSameVideoIdPlaying(nextProps.player.source.videoid)) {
              this.unblockedContent = true;
              this.isModalActive = false;
              this.afterWillReceiveProps(nextProps);
            } else {
              this.isModalActive = true;
              this.onResolveShowModal(modalData);
            }
          } else if (playersAreDifferent) {
            this.afterWillReceiveProps(nextProps);
          } // En caso de no ser diferentes (iguales los player de nextProps y this.props) no se hace nada,
          // ya que si se intenta lanzar el "afterWillReceiveProps" se hará un segundo llamado innecesario a getMedia.
        } else {
          //Continúa con el flujo que existía antes cambiando el estado de la bandera "unblockedContent".
          this.unblockedContent = false;
          if (typeof nextProps.player === 'object')
            nextProps.player.modalHasBeenShown = false;
          this.afterWillReceiveProps(nextProps);
        }
        return;
      }

      // Si no es critical y el flujo esta activo, el de
      let ifAsyncPin = false;
      // Sólo si es live
      if (window.performance) window.INICIOPLAYAPAASYNC = window.performance.now();
      if (nextProps.player.islive) {
        // sólo si trae group id (AAF player también puede recibir una url, pero en desarrollos anteriores no consideraron esto :( )
        if (nextProps.player.source && nextProps.player.source.videoid) {
          // Si entramos en nodo de TV por primera vez al arrancar la aplicación, es probable que no
          // tengamos info de si un canal es crítico o no, entonces pasa por el pin
          let channelInfo = this.getChannelInfo(nextProps.player.source.videoid);

          if (
            this.useChannelRatingFlow() &&
            !this.isCriticalChannelById(nextProps.player.source.videoid) &&
            typeof channelInfo !== 'undefined'
          ) {
            ifAsyncPin = true;
          }
          if (window.performance) {
            let entB = window.performance.now();
            console.log(
              'INICIOPLAYAPAASYNC resuelve: ' +
              (entB - window.INICIOPLAYAPAASYNC) +
              'ms'
            );
          }
        }
      }

      //console.log('[STUP] 6 Video/index pasará por async pin: ' + (ifAsyncPin ? 'SI' : 'NO'));

      if (ifAsyncPin) {
        // TODO revisar con isael el estado de las banderas
        // this.unblockedContent y nextProps.player.modalHasBeenShown
        this.unblockedContent = false;
        if (typeof nextProps.player === 'object') {
          // Si viene de un fallback, el pin ya se mostró la primera vez, la segunda ya no
          if (Utils.isNullOrUndefined(nextProps.player.deleteLastStream)) {
            nextProps.player.modalHasBeenShown = this.hasSameVideoIdPlaying(nextProps.player.source.videoid);
          }
          nextProps.player.useAsyncPin = true;
        }
        this.afterWillReceiveProps(nextProps);
      } else {
        this.updateBlockedChannels(nextProps.player).finally(() => {
          /*var entB = window.performance.now();
if(window.INICIOPLAYUPDOWN) {
  let endi = window.performance.now();
  //console.log('INICI TIME ENTRE CLIC & updateBlockedChannels: ' + (entB - window.INICIOPLAYUPDOWN));
}*/

          if (
            nextProps.player.source &&
            this.isLivePinBlocked(nextProps.player.source.videoid) &&
            !this.isFastPlay(nextProps.player.source.videoid)
          ) {
            //Se revisa si el canal está bloqueado
            nextProps.player.modalHasBeenShown = this.hasSameVideoIdPlaying(nextProps.player.source.videoid);
            if (
              (!this.unblockedContent || !this.isModalActive) &&
              this.canPlay(nextProps.player.source.videoid)
            ) {
              let isSourceReplace = true;
              nextProps.player.modalHasBeenShown = true;
              let nextOptions = nextProps.player;
              let modalData = {
                modalType: MODAL_PIN,
                successCallBack: () => {
                  this.unblockedContent = true;
                  this.isModalActive = false;
                  this.afterWillReceiveProps(nextProps);
                },
                nextOptions: nextOptions,
                isSourceReplace: isSourceReplace,
                failedCallBack: () => {
                  this.isModalActive = false;
                  if (nextOptions.islive) {
                    this.unblockedContent = false;
                  }
                }
              };
              if (this.hasSameVideoIdPlaying(nextProps.player.source.videoid)) {
                this.unblockedContent = true;
                this.isModalActive = false;
                this.afterWillReceiveProps(nextProps);
              } else {
                this.isModalActive = true;
                this.onResolveShowModal(modalData);
              }
            } else if (playersAreDifferent) {
              this.afterWillReceiveProps(nextProps);
            } // En caso de no ser diferentes (iguales los player de nextProps y this.props) no se hace nada,
            // ya que si se intenta lanzar el "afterWillReceiveProps" se hará un segundo llamado innecesario a getMedia.
          } else {
            //Continúa con el flujo que existía antes cambiando el estado de la bandera "unblockedContent".
            this.unblockedContent = false;
            if (typeof nextProps.player === 'object') {
              if(nextProps.player.source) {
                nextProps.player.modalHasBeenShown = this.hasSameVideoIdPlaying(nextProps.player.source.videoid);
              } else {
                nextProps.player.modalHasBeenShown = false;
              }
            }

            this.afterWillReceiveProps(nextProps);
          }
        });
      }
    }
  }

  afterWillReceiveProps(nextProps) {
    const {
      player: {
        source = {}
      } = {}
    } = nextProps;

    const videoid = (source && source.videoid) || null;

    const isTPA = videoid ? ThirdPartyEpgHelper.isThirdPartyApp(videoid) : null;
    let playerState = AAFPlayer.getCurrentPlayingState(false);
    let playerOptions = AAFPlayer.getCurrentPlayerOptions(false);

    // Va de live al mismo live, intenta cambiar desde TV al mismo canal que ya está actualmente playeando
    let currentLiveChannel = null;
    let nextLiveChannel = null;
    if (playerState === AAFPLAYER_PLAY && Utils.isNotNullOrNotUndefined(playerOptions.streamContentType) && playerOptions.streamContentType === constant.AAF_CONTENT_IS_TV) {
      currentLiveChannel = playerOptions && playerOptions.source && playerOptions.source.videoid;
    }

    let n = AAFPlayer.getContentType(nextProps.player);

    if(n === constant.AAF_CONTENT_IS_TV && currentLiveChannel) {
      nextLiveChannel = nextProps.player && nextProps.player.source && nextProps.player.source.videoid;
    }

    let live_to_same_live = nextLiveChannel && currentLiveChannel && nextLiveChannel === currentLiveChannel;

    if(AAFPlayer.livePlayingAsPip() || live_to_same_live) {
      this.onChangingChannel(false);
    }
    else {
      this.onChangingChannel(true);
    }

    let propsVideo = {};
    Object.assign(propsVideo, nextProps.player);
    let epgType = propsVideo.filterTV ? 'GUIDE' : null;
    if (nextProps.player.showEpg == true) {
      this.handleEpg(
        epgType,
        Utils.isNotNullOrNotUndefined(propsVideo.filterTV) ? propsVideo.filterTV : null
      );
    }

    //delete propsVideo.filterTV;
    delete propsVideo.showEpg;
    delete propsVideo.tooglePlay;
    this.ResolvegroupId = null;

    // Antes de cambiar estado del player...
    // Si actualmente esta playeando, que muestre sólo la ux para que no aparezca en el inter la barra de controles



    //si viene de pip a full y viceversa
    if (playerState === AAFPLAYER_PLAY && playerOptions.islive) {
      propsVideo.isLastPip = AAFPlayer.optionsPlayingAsPip(playerOptions);
      propsVideo.isNextPip = AAFPlayer.optionsPlayingAsPip(nextProps.player);
      propsVideo.sameSource = PlayerHelper.sameMediaContent(playerOptions, nextProps.player);
    }

    // Si actualmente playeando y live, y video
    if (
      playerState === AAFPLAYER_PLAY &&
      playerOptions.islive &&
      !playerOptions.source.hasOwnProperty('audiosource')
    ) {
      // Y lo que sigue es play...que oculte el player (y se volverá a mostrar en el onResolve)
      if (nextProps.player.playerstate === AAFPLAYER_PLAY && !nextProps.player.islive) {
        if(Utils.isNullOrUndefined(nextProps.player.starttime) && Utils.isNullOrUndefined(nextProps.player.endtime)) {
          LayersControl.showUX();
        }
      }
    }
    const nextOptions = nextProps.player;
    if (nextOptions && playerOptions) {
      if (
        playerState === AAFPLAYER_PLAY &&
        playerOptions.islive &&
        !playerOptions.source.hasOwnProperty('audiosource')
      ) {
        const nextContentType = PlayerHelper.getContentType(nextOptions);
        if (nextContentType) {
          const isSameSource = PlayerHelper.sameMediaContent(
            playerOptions,
            nextOptions,
            nextContentType
          );
          if (
            isSameSource &&
            AAFPlayer.optionsPlayingAsPip(playerOptions) &&
            !AAFPlayer.optionsPlayingAsPip(nextOptions) &&
            playerOptions.islive &&
            nextOptions.islive
          ) {
            //si es el mismo source y además viene de pip a full
            console.log(
              'FullVideo componentWillReceiveProps isSameSource && playerOptions is playing as pip && nextOptions will play as full'
            );
            LayersControl.hideUX();
          }
        }
      }
    }
    /*
  Verificar por timeshift time antes de enviar a AAF
*/

    let syncT = this.syncTimeshiftCurrentTime(nextProps);
    if (window.performance)
      console.log(
        '[TIMEMARK] en  fullvideo, enviando AAFPlayer.setPlayerState ' +
        window.performance.now()
      );

    AAFPlayer.setPlayerState(propsVideo, this.getAAFPlayerWrapper(), this.getAAFCallbacks());
    // if (isTPA) this.onChangingChannel(false);
  }

  /**
   * Calcula si resetea el timeshift current time a cero, sólo es un flag
   */
  syncTimeshiftCurrentTime(nextProps) {
    // Sólo aplica a full
    if (nextProps.player.ispip) {
      return false;
    }

    let currentAAFPlayer = AAFPlayer.getCurrentPlayingState(false);
    if (currentAAFPlayer === AAFPLAYER_PLAY) {
      if (nextProps.player.playerstate === AAFPLAYER_STOP) {
        this.state.currentTimeshiftTime = 0;
      }
      // Está en play y el siguiente estado es play
      else {
        let currentAAFPlayerParams = AAFPlayer.getCurrentPlayerOptions(false);
        // Si es audio lo actual, quiza pasa a live o a lo que sea...se resetea timeshift time
        if (
          currentAAFPlayerParams.source &&
          currentAAFPlayerParams.source.hasOwnProperty('audiosource')
        ) {
          this.state.currentTimeshiftTime = 0;
        } else {
          // Si viene desde ficha epg de evento pasado, y da clic en reiniciar evento
          if (
            nextProps.player.timeshiftData &&
            nextProps.player.timeshiftData.startprogressbar
          ) {
            this.state.currentTimeshiftTime =
              nextProps.player.timeshiftData.startprogressbar;
            return;
          }

          // Si el siguiente contenido es vod
          let next_is_live =
            nextProps.player.source &&
            (nextProps.player.source.videoid || nextProps.player.source.videosource) &&
            nextProps.player.islive === true &&
            !nextProps.player.starttime &&
            !nextProps.player.endtime;
          // Si el siguiente contenido no es timeshift o no es live se resetea
          let next_is_timeshift =
            nextProps.player.source &&
            (nextProps.player.source.videoid || nextProps.player.source.videosource) &&
            nextProps.player.islive === true &&
            nextProps.player.starttime &&
            !nextProps.player.endtime;
          let next_is_live_or_timeshift = next_is_live || next_is_timeshift;
          if (!next_is_live_or_timeshift) {
            this.state.currentTimeshiftTime = 0;
          }
          // Si es live o timeshift y es diferente group id, se resetea
          else {
            let currentGid = currentAAFPlayerParams.source.videoid;
            let nextGid = nextProps.player.source.videoid;

            if (Utils.isNullOrUndefined(currentGid)) {
              currentGid = -1; // -1 sólo para que haga diferencia con el -2 de abajo o cualquier otro valor
            }
            if (Utils.isNullOrUndefined(nextGid)) {
              currentGid = -2;
            }
            // Son groups id diferentes? reset a 0 también
            if (currentGid != nextGid) {
              this.state.currentTimeshiftTime = 0;
            }
          }
        }
      }
    }
    // Stop u otro caso, se resetea
    else {
      // Si viene desde ficha epg de evento pasado, y da clic en reiniciar evento
      if (nextProps.player.timeshiftData && nextProps.player.timeshiftData.startprogressbar) {
        this.state.currentTimeshiftTime = nextProps.player.timeshiftData.startprogressbar;
      } else {
        // Reset del flag ... no es un setState, la bandera ya existía, "no se necesita un render o algo por el estilo con esto, no es necesario un setState ...sólo es un flag ¿?"
        this.state.currentTimeshiftTime = 0;
      }
    }

    return true;
  }

  goToLastPlayedVCard(){
    const {groupId = null, streamContentType = null} = this.AAFResolvedParams || {};
    const statusUser = store.getState().user.userStatus;
    const nextGroupId = store.getState().modalKeepWatching.nextGroupId;

    if(streamContentType !== constant.AAF_CONTENT_IS_VOD) return;
    const groupIdValidate = statusUser === "anonymous" && nextGroupId.length > 0 ? nextGroupId : groupId;

    const {history}  = this.props || {};
    const {location: {pathname}} = history;
    const vcardPath = `/vcard/${groupIdValidate}`
    setValuesStoreModalKeepWatching({nextGroupId:""});
    if(pathname.includes('search')){
      // Fix para mandar al buscador cuando se viene directo desde allá sin pasar por una vcard
      history.push('/search');
    }else if (!pathname.includes(vcardPath)) {
      // Fix para mandar a la ficha del último ontenido que se estaba reproduciendo
      // Se agrega el parametro ignoreSeenLast para evitar redireccionamiento
      history.push(`${vcardPath}/1`);
    }
  }

   goBack(sendTracking) {

    this.goToLastPlayedVCard()

    let propsplayer = null;
        propsplayer = this.props.player;
        propsplayer.playerstate = 'STOPPING';

      AAFPlayer.setPlayerState(
        propsplayer,
        this.getAAFPlayerWrapper(),
        this.getAAFCallbacks()
      );

      if (this.props.player.islive) {
        this.props.setResumeData({ isBack: true });
      }
      LayersControl.showUX(); // Se para la reproducción

    if (
      this.props.player.source &&
      typeof this.props.player.source.hasOwnProperty === 'function' &&
      !this.props.player.source.hasOwnProperty('audiosource')
    ) {
      // Reset parser subtitles, just in case...
      this.resetSubtitlesParser();
    }
    window && window.youboraTrackingPlugin && window.youboraTrackingPlugin.setOptions({'content.isLive': null})
  }
}

// const mapStateToProps = (state, ownProps) => Object.assign({}, state, ownProps);
const mapStateToProps = state => {
  return { player: state.player, linealChannels: state.linealChannels };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setResumeData
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FullVideo);



// WEBPACK FOOTER //
// ./src/components/Video/FullVideo.jsx